<template lang="pug">
    .content.col
        van-nav-bar(:title='titleText', left-arrow, @click-left='onClickLeft')
        .head.col.col-center(v-if='statusText == "等待接诊"')
            img(:src='inquiryInfo.doctorPhotoUrl')
            .text-main 等待医生接诊
            .text-sub 剩余 {{ time }}
            .text-sub 已通知医生接诊，超时自动退款
        .container.col.col-center.flex-1(ref='container', v-else)
            .more-message(v-if='!isCompleted', @click='getMessageList') 更多消息
            .no-more-message(v-else) 暂无更多消息
            MessageItem(:options='item', v-for='(item, index) in messageList', :key='"messageList" + index' :serviceType="0" :patientName="patientName")
        .send-wrap.row(v-if='statusText == "已接诊"')
            .image-more
                img(src='../../assets/image/image_more.png')
                Upload(accept='.jpg, .jpeg, .png', @updateImage='sendImage', :choose='true')
            .send-input.row
                input.flex-1(type='text', v-model='inputValue', placeholder='请输入您要咨询的问题')
            .send-button.row.center(@click='send') 发送
        .footer.row.row-center(v-else) {{ statusText }}

    </template>
    <script>
    import { mapState, mapGetters } from 'vuex'
    import { showNotify, showDialog } from 'vant';
    import Upload from '@/components/upload'
    import moment from 'moment'
    import MessageItem from '@/components/messageItem/BaseMessageItem.vue'
    import eventEmitter from '@/utils/bus'
    // 公共方法
    import { getUrlParams } from '../../utils/const'

    export default {
        data() {
            return {
                time: '',
                inputValue: '',
                messageList: [],
                isCompleted: false,
                patientName: '患',
            }
        },
        components: {
            Upload,
            MessageItem,
        },
        computed: {
            ...mapGetters(['sourcePath', 'urlParams']),
            titleText() {
                const doctorname = this.inquiryInfo.doctorName || ''
                const office = this.inquiryInfo.doctorSection || ''
                return `${doctorname} ${office}`
            },
            ...mapState({
                inquiryInfo: state => state.global.inquiryInfo,
            }),
            statusText() {
                const { inquiryStatus } = this.inquiryInfo

                switch (inquiryStatus) {
                    case 0:
                        return '无'
                    case 1:
                        return '等待接诊'
                    case 2:
                        return '等待接诊'
                    case 3:
                        return '已接诊'
                    case 4:
                        return '接诊完成'
                    case 5:
                        return '问诊已取消'
                    case 6:
                        return '问诊已取消'
                    case 7:
                        return '问诊已取消'
                    default:
                        return ''
                }
            },
        },

        beforeMount() {
            if (!this.inquiryInfo.bizID) {
                this.getInfo()
            } else {
                this.getMessageList()
                this.init()
            }
            this.getUrlParams()
        },

        methods: {
            init() {
                // inquiryStatus: 问诊状态(0:无 / 1:待派单 / 2:已派单待接诊 / 3:已接诊 / 4:接诊完成 / 5:医生取消 / 6:患者取消 / 7:超时 /)
                const { inquiryStatus } = this.inquiryInfo
                switch (inquiryStatus) {
                    case 1:
                        this.computeTime()
                        break
                    case 2:
                        this.computeTime()
                        break
                    default:
                }
                if (this.logined) return
                this.logined = true
                this.tim.on(this.TIM.EVENT.MESSAGE_RECEIVED, this.onReceiveMessage)
                this.tim.on(this.TIM.EVENT.SDK_READY, this.sdkReady)
                this.trtcLogin()
                eventEmitter.on('onInvitedClient', this.onInvitedClient)
            },
            onInvitedClient(params) {
                this.$router.push({
                    path: '/calling',
                    query: {
                        ...params.detail,
                        ...this.urlParams,
                    },
                })
                // this['user/updateOrderDetail']({ ...this.orderDetail, roomID: e.roomID })
            },

            loginIM(userID, userSig) {
                this.tim.login({ userID, userSig })
            },
            sdkReady() {
                this.getMessageList()
            },
            getMessageList() {
                if (this.isCompleted) return
                let params = { conversationID: 'C2C' + this.inquiryInfo.doctorID, count: 15 }
                if (this.nextReqMessageID) params.nextReqMessageID = this.nextReqMessageID
                this.tim.getMessageList(params).then(imResponse => {
                    const messageList = imResponse.data.messageList // 消息列表。
                    console.log(messageList)
                    const nextReqMessageID = imResponse.data.nextReqMessageID // 用于续拉，分页续拉时需传入该字段。
                    const isCompleted = imResponse.data.isCompleted // 表示是否已经拉完所有消息。
                    messageList.map(message => {
                        if (typeof message.payload.data == 'string') {
                            let data = JSON.parse(message.payload.data)

                            if (data.customType == 'card' && data.childType == 'patientInfo') {
                                this.$store.commit('user/updateUserInfo', { patientInfo: JSON.parse(data.data) })
                            }
                        }
                    })
                    if (this.nextReqMessageID == 0) {
                        this.messageList.unshift(...messageList.slice(0, messageList.length - this.messageList.length))
                    } else {
                        this.messageList.unshift(...messageList)
                    }
                    this.handleScrollBottom()
                    this.nextReqMessageID = nextReqMessageID
                    this.isCompleted = isCompleted
                })
            },
            onReceiveMessage(event) {
                console.log('=========================')
                console.log(event)
                console.log('=========================')
                const message = event.data[0]
                if (typeof message.payload.data == 'string') {
                    const data = JSON.parse(message.payload.data)
                    if (data.customType == 'sys') {
                        if (data.childType == 'polymer-doctorReceipt') {
                            //医生接单
                            setTimeout(() => {
                                this.getInfo()
                            }, 1000)
                        } else if (data.childType == 'polymer-doctorRefuse') {
                            //医生拒单
                            setTimeout(() => {
                                this.getInfo()
                            }, 500)
                        } else if (data.childType == 'polymer-patientEndPoint-refresh') {
                            //问诊结束
                            setTimeout(() => {
                                this.getInfo()
                            }, 500)
                        }
                    }
                    if (data.customType == 'card' && data.childType == 'patientInfo') {
                        this.$store.commit('user/updateUserInfo', { patientInfo: JSON.parse(data.data) })
                    }
                }
                if (message.flow == 'in' && message.from !== this.inquiryInfo.doctorID) return

                this.messageList.push(message)
                this.handleScrollBottom()
            },
            // 发送消息、获取消息向下滚动
            handleScrollBottom() {
                setTimeout(() => {
                    let dom = this.$refs.container
                    if (!dom || dom.scrollHeight === 0) {
                        return false
                    }

                    dom.scrollTop = 99999999
                }, 200)
            },
            toConsulation() {
                this.$router.replace({
                    path: '/consultation',
                    query: {
                        orderID: this.urlParams.keyID,
                        token: this.urlParams.token,
                    },
                })
            },
            computeTime() {
                const timeVal = moment(this.inquiryInfo.willReceiptOrderLastTime).diff(moment())
                const tempTime = moment.duration(timeVal)
                const hours = this.formateTimeStr(tempTime.hours())
                const minutes = this.formateTimeStr(tempTime.minutes())
                const seconds = this.formateTimeStr(tempTime.seconds())
                this.time = `${hours}:${minutes}:${seconds}`
                this.timing(tempTime)
            },
            formateTimeStr(time) {
                if (`${time}`.length < 2) return `0${time}`
                else return time
            },
            timing(tempTime) {
                this.timer = setTimeout(() => {
                    let time = tempTime.add(-1, 's')
                    let hours = this.formateTimeStr(time.hours())
                    let minutes = this.formateTimeStr(time.minutes())
                    let seconds = this.formateTimeStr(time.seconds())
                    this.time = `${hours}:${minutes}:${seconds}`
                    clearTimeout(this.timer)
                    hours = null
                    minutes = null
                    seconds = null
                    this.timing(time)
                    time = null
                }, 1000)
            },
            async getInfo() {
                const { keyID } = this.$route.query
                const params = { keyID: keyID }
                const res = await this.$_http.get(this.$_API.GET_INQUERY_DETAIL_INFO, { params })
                if (res.success) {
                    this.patientName = res.data.patientName
                    this.$store.commit('user/updateOrderDetail', { ...res.data, orderPatientID: res.data.patientIMID })
                    this.$store.commit('global/updateInquiryInfo', res.data)
                    this.init()
                }
            },
            onClickLeft() {
                showDialog({
                        title: '退出提示',
                        message: '您确定要离开对话吗？',
                        theme: 'round-button',
                        showCancelButton: true,
                        cancelButtonColor: '#8C8C8C',
                        confirmButtonColor: '#438BEF',
                    })
                    .then(res => {
                        window.location.replace(this.sourcePath)
                    })
            },
            sendImage({ files, id, type }) {
                let blob = new Blob([files[0]])
                let FileMessage = null
                let message = null
                if (type === 'image') {
                    FileMessage = {
                        progress: 0,
                        from: this.inquiryInfo.patientIMID,
                        type: 'TIMImageElem',
                        src: window.URL.createObjectURL(blob),
                        payload: {
                            data: 'imageMessage',
                        },
                    }
                    message = this.tim.createImageMessage({
                        to: this.inquiryInfo.doctorID,
                        conversationType: TIM.TYPES.CONV_C2C,
                        payload: {
                            file: files[0],
                        },
                        onProgress: function(event) {
                            FileMessage.progress = event * 100
                        },
                    })
                } else if (type == 'video') {
                    FileMessage = {
                        progress: 0,
                        from: this.inquiryInfo.patientIMID,
                        type: 'TIMVideoFileElem',
                        src: window.URL.createObjectURL(blob),
                        payload: {
                            data: 'videoMessage',
                        },
                    }
                    message = _that.tim.createVideoMessage({
                        to: this.inquiryInfo.doctorID,
                        conversationType: TIM.TYPES.CONV_C2C,
                        payload: {
                            file: files[0],
                        },
                        onProgress: function(event) {
                            FileMessage.progress = event * 100
                        },
                    })
                }
                this.messageList.push(FileMessage)
                this.popupDialog = false
                this.$nextTick(() => {
                    this.handleScrollBottom()
                })
                // 2. 发送消息
                let promise = this.tim.sendMessage(message)
                promise
                    .then(function(imResponse) {
                        // 发送成功
                    })
                    .catch(imError => {
                        // 发送失败
                        console.warn('sendMessage error:', imError)
                        showNotify({
                            type: 'warning',
                            message: '发送失败',
                            duration: 1000,
                        })
                    })
            },
            trtcLogin() {
                this.$trtcCalling.loginClient({
                    userID: this.inquiryInfo.patientIMID,
                    userSig: this.inquiryInfo.imSign,
                })
            },
            // 发送消息
            send() {
                if (this.lock) return
                this.lock = true
                let _that = this
                if (this.inputValue === '') {
                    showNotify({
                        type: 'warning',
                        message: '请输入内容',
                        duration: 1000,
                    })
                    this.lock = false
                    return false
                }

                let message = this.tim.createTextMessage({
                    to: this.inquiryInfo.doctorID,
                    conversationType: TIM.TYPES.CONV_C2C,
                    payload: {
                        text: this.inputValue,
                    },
                })
                let promise = this.tim.sendMessage(message)
                promise
                    .then(imResponse => {
                        this.lock = false
                        // 发送成功
                        _that.messageList.push({
                            from: _that.inquiryInfo.patientIMID,
                            type: 'TIMTextElem',
                            payload: {
                                text: _that.inputValue,
                            },
                        })
                        _that.inputValue = ''
                        _that.handleScrollBottom()
                    })
                    .catch(imError => {
                        this.lock = false
                        // 发送失败
                        console.warn('sendMessage error:', imError)
                        showNotify({
                            type: 'warning',
                            message: '发送失败',
                            duration: 1000,
                        })
                        return false
                    })
            },
            getUrlParams() {
                if (this.$route.name === 'rpViewer') return
                let obj = getUrlParams()
                if (!obj['keyID'] || !obj['token']) {
                    showDialog({
                        message: '参数缺失，请重新进入',
                        confirmButtonText: '确定',
                        confirmButtonColor: '#438BEF',
                        closeOnClickOverlay: true,
                    })
                }
                this.$store.commit('global/updateUrlParams', obj)
            },
        },
    }
    </script>
    <style lang="stylus" scoped>
    .content
        display: flex
        width: 100vw
        height: 100vh
        background: #F8F8FA
        position: relative
        padding-bottom: 100px
        box-sizing: border-box
        .head
            height: 154px
            background: #fff
            img
                height: 56px
                width: 56px
                border-radius: 50%
                margin-top: 14px
            .text-main
                font-size: 16px
                margin-top: 8px
                color: #333333
            .text-sub
                font-size: 12px
                color: #999999
                margin-top: 4px
        .container
            overflow-y: auto
        .footer
            position: fixed
            width: 100vw
            background: #fff
            bottom: 0
            left: 0
            height: 82px
            color: #999999
            font-size: 16px
            padding-top: 15px
            box-sizing: border-box
        .send-wrap
            display: flex
            align-items: center
            position: fixed
            bottom: 0
            left: 0
            width: 100vw
            height: 86px
            background: #fff
            padding: 8px 16px
            box-sizing: border-box
            .image-more
                position: relative
                img
                    display: flex
                    height: 24px
                    width: 24px
                .upload-input-cover
                    opacity: 0
                    position: absolute
                    height: 30px
                    width: 30px
                    top: 0px
                    left: 0px
            .send-input
                width: calc(100vw - 140px)
                height: 36px
                overflow: hidden
                margin: 0 12px
                padding: 2px 6px
                box-sizing: border-box
                input
                    font-size: 14px
                    border-radius: 19.5px
                    padding: 0 16px
                    // width: 100%
                    // height: 100%
                    background: #EEEEEE
            .send-button
                width: 60px
                height: 36px
                border-radius: 24px
                opacity: 1
                font-size: 14px
                color: #fff
                background: linear-gradient(90deg, rgba(134, 174, 252, 1) 0%, rgba(36, 90, 234, 1) 100%)
        .more-message, .no-more-message
            color: #2887e8
            font-size: 13px
            padding: 10px 10px 0
            text-align: center
            margin-bottom: 12px
    </style>
